import React from "react";
import * as styles from "./index.module.scss";

import Helmet from "react-helmet";

import Footer from "@components/footer";
import Header from "@components/header";
import TextCenterBanner from "@components/textCenterBanner";
import { useI18n } from "@src/i18n";

import phoneImg from "@src/images/agreement/Rectangle4386.png";
import pcImg from "@src/images/agreement/Rectangle4387.png";

import { Col, Collapse, Row } from "antd";

const AgreementPage = () => {
  const { t } = useI18n();
  const renderDates = t("agreementPage.sections");

  return (
    <div className={styles.agreementPage}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("agreementPage.title")}</title>
      </Helmet>
      <Header />
      <TextCenterBanner pcImg={pcImg} phoneImg={phoneImg} text={t("agreementPage.banner")} />
      <div>
        <div className={styles.contentHeader}>
          {t("agreementPage.header")}
          <br />
          <br />
          <br />
          {t("agreementPage.prohibited")}
        </div>
        <Row>
          <Col xs={0} sm={0} md={24}>
            <div className={styles.contentMain}>
              {renderDates.map((item) => (
                <div className={styles.mainItem} key={item.title}>
                  <div className={styles.mainTitle}>{item.title}</div>
                  <div>{item.detail}</div>
                  {item.date && (
                    <div
                      style={{
                        float: "right",
                        marginTop: "64px",
                        marginBottom: "100px",
                      }}
                    >
                      {item.date.map((item, index) => {
                        return <div key={index}>{item}</div>;
                      })}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </Col>
          <Col xs={24} sm={24} md={0}>
            <Collapse
              // defaultActiveKey={["1"]}
              expandIconPosition="right"
              className={styles.phoneShowBox}
              style={{ marginTop: "30px" }}
              bordered={false}
            >
              {renderDates.map((item) => (
                <Collapse.Panel
                  header={
                    <div style={{ paddingLeft: "8px" }}>{item.title}</div>
                  }
                  key={item.title}
                >
                  <div className={styles.pannel}>
                    <div style={{ paddingLeft: "8px" }}>{item.detail}</div>
                    {item.date && (
                      <div className={styles.date}>
                        {item.date.map((item, index) => (
                          <div key={index}>{item}</div>
                        ))}
                      </div>
                    )}
                  </div>
                </Collapse.Panel>
              ))}
            </Collapse>
          </Col>
        </Row>
      </div>

      <Footer />
    </div>
  );
};
export default AgreementPage;
